import { render, staticRenderFns } from "./HqHrJiangLiPerson.vue?vue&type=template&id=5e8c0a72&scoped=true"
import script from "./HqHrJiangLiPerson.vue?vue&type=script&lang=js"
export * from "./HqHrJiangLiPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8c0a72",
  null
  
)

export default component.exports